var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00392 3.6761L10.3727 0L16.7415 3.6761L14.4 5.03415L10.3727 2.7161L6.34539 5.03415L4.00392 3.6761ZM16.7415 8.31219L14.4 6.95415L10.3727 9.2722L6.34539 6.95415L4.00392 8.31219V11.0283L8.03123 13.3463V17.9824L10.3727 19.3405L12.7142 17.9824V13.3463L16.7415 11.0283V8.31219ZM16.7415 15.6644V12.9483L14.4 14.3063V17.0224L16.7415 15.6644ZM18.4039 16.6244L14.3766 18.9424V21.6585L20.7454 17.9824V10.6302L18.4039 11.9883V16.6244ZM16.0625 5.99415L18.4039 7.35219V10.0683L20.7454 8.71024V5.99415L18.4039 4.6361L16.0625 5.99415ZM8.03123 19.9259V22.642L10.3727 24L12.7142 22.642V19.9259L10.3727 21.2839L8.03123 19.9259ZM4.00392 15.6644L6.34539 17.0224V14.3063L4.00392 12.9483V15.6644ZM8.03123 5.99415L10.3727 7.35219L12.7142 5.99415L10.3727 4.6361L8.03123 5.99415ZM2.34146 7.35219L4.68293 5.99415L2.34146 4.6361L0 5.99415V8.71024L2.34146 10.0683V7.35219ZM2.34146 11.9883L0 10.6302V17.9824L6.36877 21.6585V18.9424L2.34146 16.6244V11.9883Z",
    fill: "#F0B90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.8a50adcb7ab10330c08c08a8a56e8978.svg";
export { ForwardRef as ReactComponent };